import { Component } from '@angular/core';

@Component({
  selector: 'app-condiciones-envio',
  templateUrl: './condiciones-envio.component.html',
  styleUrls: ['./condiciones-envio.component.scss']
})
export class CondicionesEnvioComponent {

}
